import { gql } from '@apollo/client';
import { CREDIT_DECISION_PARSED_DATA_FRAGMENT } from 'modules/creditSubmission/api';

export const GET_CREDIT_SUBMISSIONS = gql`
  ${CREDIT_DECISION_PARSED_DATA_FRAGMENT}
  query CreditSubmissionsByDynamicsVOId($id: ID!, $display: String) {
    creditSubmissionsByDynamicsVOId(id: $id, display: $display) {
      creditSubmissionId
      creditSubId
      submissionDate
      decision
      lenderName
      amountRequested
      approvedAmount
      notes
      internalNotes
      contingencies
      approvedRate
      creditSubStage
      apiApplicationId
      apiResult
      apiExpiredCredentials
      apiDetail
      lenderProfileId
      lenderChannelCode
      lenderTypeCode
      draft
      creditSubStage
      transactionSummary
      mappedValues
      source
      submittedBy
      creditSubmissionDeclineReasonId
      lenderContactInfo {
        id
        email
        dynamicsContactId
        fullName
        title
        phoneNumber
        accountId
      }
      fastTrackResults {
        approvedBy
        fastTrackId
        maxApprovalAmount
        rate
        inputs {
          key
          value
        }
        outputs {
          key
          value
        }
      }
      proposals {
        proposalId
        status
        createdSnapshot
        createdDateTime
      }
      creditDecisionParsedData {
        ...CreditDecisionParsedDataFields
      }
    }
  }
`;

export const SUBMIT_APP = gql`
  mutation ($input: CreditSubmissionInput!) {
    createCreditSubmission(input: $input)
  }
`;
